import { FC } from 'react';
import { useQuery } from 'react-query';
import { isNotEmpty, QUERIES } from '../../../../../_dashboard/helpers';
import { useListView } from '../core/ListViewProvider';
import { getOneById } from '../../../../services/common_requests';
import { initialAgency } from '../core/_models';
import { AgencyEditModalForm } from './AgencyEditModalForm';

const AgencyEditModalFormWrapper: FC = () => {
  const { itemIdForUpdate } = useListView();
  const enabledQuery = isNotEmpty(itemIdForUpdate);

  const { isLoading, data: agency } = useQuery(
    `${QUERIES.AGENCIES_LIST}-agency-${itemIdForUpdate}`,
    () => getOneById(itemIdForUpdate, '/agencies'),
    { cacheTime: 0, enabled: enabledQuery }
  );

  if (!itemIdForUpdate) {
    return <AgencyEditModalForm isAgencyLoading={false} Agency={initialAgency} />;
  }

  if (isLoading) return null;

  return <AgencyEditModalForm isAgencyLoading={isLoading} Agency={agency || initialAgency} />;
};

export { AgencyEditModalFormWrapper };
